import React from "react";
import { Box, Button, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import { ASSETS_BASE_URL } from "../../config";
import useBrandingAssets from "../../hooks/useBrandingAssets";

const PageListItem = ({ page, onNavigate }) => {
  const navigate = useNavigate();
  const { stockImageUrl } = useBrandingAssets();
  const fallbackImage = page?.fallback || stockImageUrl || `${ASSETS_BASE_URL}/stock.png`;
  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate(page);
      return;
    }
    navigate(page.href);
  };
  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "75px",
        borderRadius: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fff",
        boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)",
        p: 2,
        columnGap: 2,
        margin: "7px 0",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
        {page.image && (
          <img
            style={{ height: "50px", width: "50px" }}
            src={page.image}
            alt={page.name}
            onError={(e) => {
              e.currentTarget.src = fallbackImage;
            }}
          />
        )}
        <Box>
          <Typography variant="body1" sx={{ fontWeight: "bold", fontSize: "12px" }}>
            {page.name}
          </Typography>
          {page.sub_name && (
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: "11px" }}>
              {page.sub_name}
            </Typography>
          )}
        </Box>
      </Box>
      <Button size="small" endIcon={<LinkIcon />} onClick={handleNavigate}>
        Visit Page
      </Button>
    </Box>
  );
};

export default PageListItem;